module.exports = "/_next/static/images/techminisOrange-ecc202e9b2296e9459c1ddb421c63677.svg";